export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POST = 'NEW_POST';

//-------------------------------- Application --------------------------------//

export const ON_ROUTE_CHANGE = 'ON_ROUTE_CHANGE';

export const SHOW_SUCCESSFUL_MESSAGE = 'SHOW_SUCCESSFUL_MESSAGE';
export const SHOW_INFO_MESSAGE = 'SHOW_INFO_MESSAGE';
export const SHOW_WARNING_MESSAGE = 'SHOW_WARNING_MESSAGE';
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';

export const UPDATE_SHOW_MESSAGE = 'UPDATE_SHOW_MESSAGE';

export const LOGGED_IN_MESSAGE = 'LOGGED_IN_MESSAGE';

export const UPDATE_SHOW_LOADING = 'UPDATE_SHOW_LOADING';

export const ON_USER_PICTURE_CHANGE = 'ON_USER_PICTURE_CHANGE';
export const ON_NOTIFICATION_RECEIVED = 'ON_NOTIFICATION_RECEIVED';

export const USER_LOGOUT = 'USER_LOGOUT';


//-------------------------------- Application --------------------------------//

//-------------------------------- Login --------------------------------//
export const ON_LOGIN_SUCCESS = 'ON_LOGIN_SUCCESS';
export const ON_LOGIN_FAIL = 'ON_LOGIN_FAIL';


//-------------------------------- SaleOrder --------------------------------//
export const SALEORDER_UPDATE_PRODUCT = 'SALEORDER_UPDATE_PRODUCT';
export const SALEORDER_UPDATE_PROJECT = 'SALEORDER_UPDATE_PROJECT';
export const SALEORDER_UPDATE_CUSTOMER = 'SALEORDER_UPDATE_CUSTOMER';
export const SALEORDER_UPDATE_YEARSPAYMENT = 'SALEORDER_UPDATE_YEARSPAYMENT';
export const SALEORDER_UPDATE_CAMPAIGN = 'SALEORDER_UPDATE_CAMPAIGN';
export const SALEORDER_UPDATE_INITIAL_QUOTA = 'SALEORDER_UPDATE_INITIAL_QUOTA';
export const SALEORDER_UPDATE_PAYMENTCONDITION = 'SALEORDER_UPDATE_PAYMENTCONDITION';
export const SALEORDER_NEGOTIATE = 'SALEORDER_NEGOTIATE';
export const SALEORDER_CLEAN_NEGOTIATE = 'SALEORDER_CLEAN_NEGOTIATE';
export const SALEORDER_UPDATE_SPOTTREESELECTION = 'SALEORDER_UPDATE_SPOTTREESELECTION';
export const SALEORDER_SUCCESSFUL_POST = 'SALEORDER_SUCCESSFUL_POST';
export const SALEORDER_CLEAN_STATE = 'SALEORDER_CLEAN_STATE';
export const SALEORDER_SUCCESSFUL_GET = 'SALEORDER_SUCCESSFUL_GET';
export const SALEORDER_SUCCESSFUL_UPDATE_PRODUCT = 'SALEORDER_SUCCESSFUL_UPDATE_PRODUCT';
export const SALEORDER_SUCCESSFUL_UPDATE_NEGOTIATION = 'SALEORDER_SUCCESSFUL_UPDATE_NEGOTIATION';
//-------------------------------- SaleOrder --------------------------------//

//-------------------------------- SaleOrders --------------------------------//
export const SALEORDERS_SUCCESSFUL_GET = 'SALEORDERS_SUCCESSFUL_GET';
export const SALEORDERS_UPDATE_FILTERCUSTOMER = 'SALEORDERS_UPDATE_FILTERCUSTOMER';
export const SALEORDERS_UPDATE_FILTERSTATUS = 'SALEORDERS_UPDATE_FILTERSTATUS';
export const SALEORDERS_UPDATE_FILTERSTARTDATE = 'SALEORDERS_UPDATE_FILTERSTARTDATE';
export const SALEORDERS_UPDATE_FILTERENDDATE = 'SALEORDERS_UPDATE_FILTERENDDATE';
export const SECOND_SALEORDER_QUALIFICATION_SUCCESSFUL_GET = 'SECOND_SALEORDER_QUALIFICATION_SUCCESSFUL_GET';
//-------------------------------- SaleOrders --------------------------------//

//-------------------------------- Projects --------------------------------//
export const PROJECTS_COMMERCIAL_SUCCESSFUL_FETCH = 'PROJECTS_COMMERCIAL_SUCCESSFUL_FETCH';
export const PROJECTS_PARENTS_SUCCESSFUL_FETCH = 'PROJECTS_PARENTS_SUCCESSFUL_FETCH';
export const PROJECTS_SUCCESSFUL_YEARSTERM = 'PROJECTS_SUCCESSFUL_YEARSTERM';
export const PROJECTS_SUCCESSFUL_CAMPAIGN = 'PROJECTS_SUCCESSFUL_CAMPAIGN';

//-------------------------------- Projects --------------------------------//

//-------------------------------- Products --------------------------------//
export const PRODUCTS_SUCCESSFUL_FETCH = 'PRODUCTS_SUCCESSFUL_FETCH';
//-------------------------------- Products --------------------------------//

//-------------------------------- Customers --------------------------------//
export const CUSTOMERS_SUCCESSFUL_FETCH = 'CUSTOMERS_SUCCESSFUL_FETCH';
export const CUSTOMERS_SUCCESSFUL_SAVE = 'CUSTOMERS_SUCCESSFUL_SAVE';
//-------------------------------- Customers --------------------------------//

//-------------------------------- Afiliate --------------------------------//
export const AFILLIATE_SUCCESSFUL_FETCH = 'AFILLIATE_SUCCESSFUL_FETCH';
export const AFILLIATE_SUCCESSFUL_SAVE = 'AFILLIATE_SUCCESSFUL_SAVE';
//-------------------------------- Customers --------------------------------//

//-------------------------------- ProjectsView --------------------------------//
export const PROJECTSVIEW_UPDATE_PRODUCT = 'PROJECTSVIEW_UPDATE_PRODUCT';
export const PROJECTSVIEW_UPDATE_PARENT_PROJECT = 'PROJECTSVIEW_UPDATE_PARENT_PROJECT';
export const PROJECTSVIEW_UPDATE_COMMERCIAL_PROJECT = 'PROJECTSVIEW_UPDATE_COMMERCIAL_PROJECT';
export const PROJECTSVIEW_CLEAN = 'PROJECTSVIEW_CLEAN';
//-------------------------------- ProjectsView --------------------------------//


//-------------------------------- Wallet --------------------------------------//
export const WALLET_SUCCESSFUL_GET = 'WALLET_SUCCESSFUL_GET';
export const WALLET_UPDATE_FILTERTRANSACTIONTYPE = 'WALLET_UPDATE_FILTERTRANSACTIONTYPE';
export const WALLET_UPDATE_FILTERACCOUNTTRANSTYPE = 'WALLET_UPDATE_FILTERACCOUNTTRANSTYPE';
export const WALLET_UPDATE_FILTERSTARTDATE = 'WALLET_UPDATE_FILTERSTARTDATE';
export const WALLET_UPDATE_FILTERENDDATE = 'WALLET_UPDATE_FILTERENDDATE';
export const WALLET_SUCCESSFUL_BALANCE_AMOUNT = 'WALLET_SUCCESSFUL_BALANCE_AMOUNT';
export const WALLET_SUCCESSFUL_TRANSFER = 'WALLET_SUCCESSFUL_TRANSFER';
//-------------------------------- Wallet --------------------------------------//


//-------------------------------- Party --------------------------------------//
export const PARTY_SUCCESSFUL_FETCH = 'PARTY_SUCCESSFUL_FETCH';
//-------------------------------- Party --------------------------------------//


//-------------------------------- Disbursement Request --------------------------------------//
export const DISBURSEMENTREQUEST_SUCCESSFUL_GET = "DISBURSEMENTREQUEST_SUCCESSFUL_GET"
export const DISBURSEMENTREQUEST_UPDATE_FILTERSTATUS = "DISBURSEMENTREQUEST_UPDATE_FILTERSTATUS"
export const DISBURSEMENTREQUEST_UPDATE_FILTERSTARTDATE = "DISBURSEMENTREQUEST_UPDATE_FILTERSTARTDATE"
export const DISBURSEMENTREQUEST_UPDATE_FILTERENDDATE = "DISBURSEMENTREQUEST_UPDATE_FILTERENDDATE"
export const DISBURSEMENTREQUEST_SUCCESSFUL_INFO_GET = "DISBURSEMENTREQUEST_SUCCESSFUL_INFO_GET"
export const DISBURSEMENTREQUEST_SUCCESSFUL_HISTORY_GET = "DISBURSEMENTREQUEST_SUCCESSFUL_HISTORY_GET"
export const DISBURSEMENTREQUEST_SUCCESSFUL_ANNULMENT = "DISBURSEMENTREQUEST_SUCCESSFUL_ANNULMENT"
//-------------------------------- Disbursement Request --------------------------------------//


//-------------------------------- Seller ---------------------------------------------------//
export const SELLER_CONTRACT_TYPE_SUCCESSFUL_GET = "SELLER_CONTRACT_TYPE_SUCCESSFUL_GET"
export const SELLER_UPDATE_CONTRACT_TYPE = "SELLER_UPDATE_CONTRACT_TYPE"
//-------------------------------- Seller ---------------------------------------------------//

//-------------------------------- Person ---------------------------------------------------//
export const SEARCH_PERSON_SUCCESSFUL_FETCH = "SEARCH_PERSON_SUCCESSFUL_FETCH";

//-------------------------------- Unlock Request ---------------------------------------------------//
export const UNLOCKETREQUEST_SUCCESSFUL_GET = "UNLOCKETREQUEST_SUCCESSFUL_GET";


// WEBPACK FOOTER //
// ./src/reducers/constants.js